export default async ({ store, redirect, route }) => {
  const type = store.state.global.user?.membership?.type;
  if (type !== 'EXECUTIVE' && type !== 'PRO') {
    return redirect(`/upgrade?from=${route.path}`);
  }
};
